/**
 * File: EmailField.js
 * Origin: isotect
 * Description: EmailField component for authentication forms.
 *
 * Version: v2.0.0
 * Created: 2025-07-24
 * Last Updated: 2026-01-21
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * EmailField component renders an input field for email entry
 * in authentication forms.
 *
 * @component
 *
 * @returns {JSX.Element} An email input field with proper type and accessibility attributes
 *
 * @example
 * <EmailField />
 */
function EmailField({ email, setEmail }) {
    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    return (
        <>
            <div className="email-field">
                <label htmlFor="email" className="email-field__label">
                    Email
                </label>
                <input
                    type="email"
                    name="email"
                    id="email"
                    size="30"
                    maxLength="100"
                    required
                    pattern="[^ @]+@[^ @]+\.[a-z]+"
                    placeholder="Email"
                    value={email}
                    onChange={handleChange}
                />
            </div>
        </>
    );
}

export default EmailField;
